// What this version can send of a template, shared by the inbox composer and
// campaigns.
import type { MessageTemplate } from '../api/templates'

const namedVar = /\{\{\s*[^{}\d\s][^{}]*\}\}/
const linkVar = /\{\{\s*1\s*\}\}$/

// Approved, text header at most, numbered variables, at most one link
// variable. The server checks the same rules.
export function sendable(t: MessageTemplate): boolean {
  if (t.status !== 'approved' || t.hasMediaHeader) return false
  if (namedVar.test(t.body) || namedVar.test(t.header ?? '')) return false
  return t.buttons.filter((b) => b.type === 'url' && linkVar.test(b.url ?? '')).length <= 1
}

// A website button whose address ends with {{1}}.
export function hasLinkVariable(t: MessageTemplate): boolean {
  return t.buttons.some((b) => b.type === 'url' && linkVar.test(b.url ?? ''))
}
